<template>
	<div class="indexView">
		<el-container>
			<el-main>
				<HeaderRow selUrl="about"></HeaderRow>
				<div class="banner" v-if="navList[4]&&navList[4].icon_image">
					<el-image style="width: 100%; height: 300px" fit="cover" :src="navList[4].icon_image"></el-image>
				</div>
				<div class="breadcrumb">
					<div class="backItem" @click="()=>$router.back()"><i class="el-icon-arrow-left">返回</i></div>
					<el-breadcrumb separator="/">
						<el-breadcrumb-item to="/">首页</el-breadcrumb-item>
						<el-breadcrumb-item to="/about">关于我们</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				<div class="aboutDiv">
					<h1>关于我们</h1>
					<p>
						语之乐是一家正规注册、取得相关资质，主要从事青少年写作教育研究与培训的艺术机构，经过二十多年的发展，现已研发系列课程三十级，共计上千节课。课程针对学习者，主要解决人文思想、文学思维、写作方法、文学积淀、文学作品阅读鉴赏及创作实践等方面遇到的问题。
					</p>
					<p>
						课程分为文学启蒙、文学基础、文学创作三大板块。文学启蒙一共七级，课程包括国学积累、人文思想训练、文学思维训练、看图写话训练、语感训练等内容，培养学习者联想力、想象力和表达能力；文学基础一共十六级，课程包括文学积累、人文思想训练、文学思维训练、景物（人物）细节描写、不同文学体裁（散文、小说、现代诗）文章的构篇方法、不同文学体裁文章的选材与主题提炼、表达的角度与创新；文学创作课程主要学习散文、小说与现代诗创作的常见方法，通过案例分析、仿写、实践的训练过程，引导初学文学创作者快速入门。
					</p>
					<p>
						针对青少年学生，本课程体系可以解决无法动笔、写不长、写不具体、写不生动、跑题偏题、没有条理、主题肤浅等问题，通过学习，可以将作文提升为作品。针对文学爱好者，学习本课程体系可以打好扎实的基本功，快速掌握各种文学体裁的特征，学习三大类文学体裁常见的创作方法与技巧，能够快速入门。
					</p>
					<p>
						针对中高考本机构开发的课程，主要是结合中、高考写作评分标准，有针对性的以解决实际问题为目的的训练体系。学习文学创作，能够帮助考生少走弯路，把作文变成作品，提升文章质量。</p>

					<h1>企业文化</h1>
					<p>学好写作、受益一生</p>

					<h1>教育理念</h1>
					<p>“激发兴趣，培养习惯，塑造品格”</p>
					<p>我们不仅关注学生学习成绩的提高，更关注学生学习兴趣的激发、学习习惯的培养和思维模式的塑造</p>
					<h2>激发兴趣</h2>
					<p>兴趣是较好的老师，我们通过激发学生的学习兴趣，帮助学生树立信心，培养学生的成就感，让孩子的学习充满动力。</p>
					<h2>培养习惯</h2>
					<p>通过培养孩子好的学习习惯和生活习惯，帮助学生取得全面的进步。</p>
					<h2>塑造品格</h2>
					<p>
						通过学生思维模式的塑造，改变其行为习惯，进而全面作用于学生的学习动力、学习环境和学习能力，终提生的综合素质。</p>

					<h1>联系方式</h1>
					<p>热线电话：188000000</p>
					<p>联系邮箱：xxx@xx.com</p>
					<p>联系地址：XXX省XXX市XXX县XXX路XXX号</p>
				</div>
				<FooterRow></FooterRow>
			</el-main>
		</el-container>
	</div>
</template>

<script>
	import indexjs from "./index.js";
	import {
		copy
	} from "clipboard";
	import HeaderRow from "@/components/headerRow.vue";
	import FooterRow from "@/components/footerRow.vue";

	export default {
		methods: {
			copy,
		},
		...indexjs,
		components: {
			HeaderRow,
			FooterRow,
		},
		computed: {},

	};
</script>

<style lang="scss" scoped>
	@import "./index.scss";
</style>